import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { HiDotsVertical } from 'react-icons/hi';
import { Button, DropdownToggle } from 'modules/theme';
import styled from 'styled-components';

const DropdownStyle = styled.div`
  ul li {
    padding: 0px !important;
  }
  ul {
    padding:${(props) => (props.customPadding ? props.customPadding : '5px 0px' )}!important ;
    z-index: 1;
  }
  .dropdown.btn-group {
    margin-top: 1px !important;
  }
`;

const CustomDropdown = (props) => {
  const { children, dropup, styleBtn,index ,totalLength } = props;
  let newDropup=false;
  const totalOptions  =( Array.isArray(children) && children.length ) || 1;
  if (  Number.isInteger(totalLength) && Number.isInteger(index) && (totalLength > totalOptions) && (index === (totalLength-1)))
  {
    newDropup=true;
  }
  return (
    <DropdownStyle customPadding={props.customPadding}>
      <Dropdown
        dropup={newDropup}
        id='dropdown-engage'
        pullRight
        style={{ marginTop: '0px', zIndex: "zIndex" in props ? props.zIndex : "unset" }}
      >
        <DropdownToggle bsRole='toggle'>
          <Button style={{ ...styleBtn }} btnStyle='link' size='medium'>
            <HiDotsVertical style={{ fontSize: '17px' }} />
          </Button>
        </DropdownToggle>
        <Dropdown.Menu>{children}</Dropdown.Menu>
      </Dropdown>
    </DropdownStyle>
  );
};

export default CustomDropdown;



// WEBPACK FOOTER //
// src/modules/common/components/Dropdown.js